import { registerTool } from '../ToolRegistry'
import { getSharedToolRegistration } from '../sharedToolCatalog'
import { useMonsterStore } from '@/stores'

const normalize = (value) =>
  String(value || '')
    .trim()
    .toLowerCase()

async function ensureMonsterList(monsterStore) {
  await monsterStore.fetchMonsters?.()
  return Array.isArray(monsterStore.monsters) ? monsterStore.monsters : []
}

export function registerMonsterTools() {
  registerTool({
    ...getSharedToolRegistration('search_monsters'),
    handler: async (args) => {
      try {
        const query = normalize(args?.query || '')
        if (!query) return { ok: false, error: 'Please provide a query.' }
        const limit = Math.max(1, Math.min(Number(args?.limit) || 10, 50))
        const monsterStore = await useMonsterStore()
        const monsters = await ensureMonsterList(monsterStore)
        const matches = monsters
          .filter((m) => {
            const name = normalize(m?.name || m?.title || m?.index || '')
            const index = normalize(m?.index || '')
            return name.includes(query) || index.includes(query)
          })
          .slice(0, limit)
        return { ok: true, count: matches.length, monsters: matches }
      } catch (e) {
        return { ok: false, error: e?.message || 'Failed to search monsters' }
      }
    }
  })

  registerTool({
    ...getSharedToolRegistration('list_monsters'),
    handler: async (args) => {
      try {
        const monsterStore = await useMonsterStore()
        const monsters = await ensureMonsterList(monsterStore)
        const crFilter = args?.cr !== undefined && args?.cr !== null ? Number(args.cr) : null
        const typeFilter = typeof args?.type === 'string' && args.type.trim().length > 0
        const typeNeedle = typeFilter ? normalize(args.type) : null
        const limit = Math.max(1, Math.min(Number(args?.limit) || 50, 200))
        const filtered = monsters.filter((m) => {
          if (crFilter !== null && Number(m.cr || m.challenge_rating) !== crFilter) return false
          if (typeNeedle && !normalize(m.type || '').includes(typeNeedle)) return false
          return true
        })
        const sliced = filtered.slice(0, limit)
        const formatted = sliced
          .map((m, idx) => `${idx + 1}. ${m.name} (CR ${m.cr || '?'}, ${m.type || 'unknown'})`)
          .join(' ')
        return { ok: true, count: sliced.length, monsters: sliced, formatted }
      } catch (e) {
        return { ok: false, error: e?.message || 'Failed to list monsters' }
      }
    }
  })
}
